import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../config/axiosApi/axiosApi";
import APIs from "../../../Constants/apis";
import Select from "react-select";
import DropDownStyles from "../../../pages/staff/dropdownStyles";

const CountrySelectionDropDown = ({
  defaultValue,
  onChange,
  setLoading,
  styles,
  placeholder = "Select Country"
}) => {
  const [countries, setCountries] = useState([]);
  const [internalLoading, setInternalLoading] = useState(false);

  const FetchCountries = useCallback(async () => {
    try {
      if (setLoading) {
        setLoading(true);
      } else {
        setInternalLoading(true);
      }
      
      const response = await axiosInstance.get(APIs.GET_COUNTRIES);
      const roleData = response.data.data || response.data;

      const mappedOptions = roleData.map((country) => ({
        value: country.code,
        label: country.name,
      }));
      setCountries(mappedOptions);
      
      if (setLoading) {
        setLoading(false);
      } else {
        setInternalLoading(false);
      }
    } catch (err) {
      if (setLoading) {
        setLoading(false);
      } else {
        setInternalLoading(false);
      }
    }
  }, [setLoading]);

  useEffect(() => {
    FetchCountries();
  }, [FetchCountries]);

  return (
    <>
      <Select
        value={defaultValue}
        onChange={onChange}
        options={countries}
        styles={styles || DropDownStyles}
        placeholder={placeholder}
        isClearable={true}
        isLoading={internalLoading}
      />
    </>
  );
};

export default CountrySelectionDropDown;
export { CountrySelectionDropDown };
